import { AbstractIndexSection } from '../../abstract-index-section';

export abstract class AbstractIndexCustom extends AbstractIndexSection<any> {
  belongSiteModules = [];
  limit = 0;
  defaultData: any;
  remoteDefaultData: any;

  refreshRemoteData(): void {}
}
